/**
 * commonコンスト
 */

// カレンダーの表示モード
/** 月 */
export const VIEWMODE_DAY_GRID_MONTH: string = `dayGridMonth`;
/** 日 */
export const VIEWMODE_TIME_GRID_DAY: string = `timeGridDay`;
/** リスト */
export const VIEWMODE_LIST_MONTH: string = `listMonth`;
/** リスト */
export const VIEWMODE_LIST_WEEK: string = `listWeek`;

// sessionStrageで管理しているキー
/** トークン */
export const SESSION_KEY_TOKEN: string = `token_s_u`;
/** config */
export const SESSION_KEY_CONFIG: string = `config_s_u`;
/** 休日情報 */
export const SESSION_KEY_HOLIDAYS: string = `holidays_s_u`;
/** カレンダーの表示モード */
export const SESSION_KEY_VIEW_MODE: string = `viewMode_s_u`;
/** カレンダーの表示開始日 */
export const SESSION_KEY_START_VIEW_DATE: string = `startViewDate_s_u`;
/** カレンダーの表示終了日 */
export const SESSION_KEY_END_VIEW_DATE: string = `endViewDate_s_u`;

// 予約種別（リスト表示用）
export const BOOKING_TYPE_NAME_TAKEOUT_FOR_LIST: string = `持出し`;
export const BOOKING_TYPE_NAME_POMPOUT1_FOR_LIST: string = `汲出し1`;
export const BOOKING_TYPE_NAME_POMPOUT2_FOR_LIST: string = `汲出し2`;

// 予約種別
export const BOOKING_TYPE_NAME_TAKEOUT: string = `溶媒持出し`;
export const BOOKING_TYPE_NAME_POMPOUT1: string = `溶媒汲出し１`;
export const BOOKING_TYPE_NAME_POMPOUT2: string = `溶媒汲出し２`;

// 予約種別ごとの色
export const BOOKING_TYPE_COLOR_TAKEOUT: string = `mediumseagreen`;
export const BOOKING_TYPE_COLOR_POMPOUT1: string = `goldenrod`;
export const BOOKING_TYPE_COLOR_POMPOUT2: string = `sienna`;
// 午前・午後の仕切り枠の色
export const EVENT_PARTITION_COLOR: string = `#a9a9a9`;
// 午前・午後の仕切り枠のクラス名
export const BOOKING_TYPE_CLASS_EVENT_PARTITION: string = `eventPatition`;

// 予約種別ごとのclass名
export const BOOKING_TYPE_CLASS_TAKEOUT: string = `takeOut`;
export const BOOKING_TYPE_CLASS_POMPOUT1: string = `pompOut1`;
export const BOOKING_TYPE_CLASS_POMPOUT2: string = `pompOut2`;

// イベントのグループID
export const GROUP_ID_HOLIDAY: string = `holiday`;
export const GROUP_ID_FREE: string = `free`;
export const GROUP_ID_BOOKING: string = `booking`;

// イベント表示種別
export const EVENT_DISPLAY_BOOKING: string = ``;
export const EVENT_DISPLAY_HOLIDAY: string = `background`;
// 休日の色
export const EVENT_HOLIDAY_COLOR: string = `#D7D7D7`;

/** 単位名（kg） */
export const UNIT_NAME_KG: string = `kg`;
/** 単位名（L） */
export const UNIT_NAME_L: string = `ℓ`;

/** 予約種類選択ダイアログ */
export const SELECT_BOOKING_TYPE_DIALOG: number = 0;
/** 予約時間選択ダイアログ */
export const SELECT_BOOKING_TIME_DIALOG: number = 1;
/** 溶媒選択ダイアログ */
export const SELECT_SOLVENT_DIALOG: number = 2;
/** 予約者情報登録ダイアログ */
export const SUBSCRIBER_INFO_DIALOG: number = 3;

/** レスポンシブ切り替え値 */
export const RESPONSIVE_MIN_WIDTH: string = `(min-width:768px)`;
